module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/components/product-selection-type-list/product-selection-type-list.component.scss
// module id = ./src/app/modules/backstage-module/components/product-selection-type-list/product-selection-type-list.component.scss
// module chunks = 9